import { useEffect, useState } from "react";
import api, { fmtTRY, API } from "../lib/api";
import { Button } from "../components/ui/button";
import { FileDown, FileSpreadsheet } from "lucide-react";
import { toast } from "sonner";

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reports/pl").then((r) => setData(r.data)); }, []);

  const download = async (fmt) => {
    try {
      const token = localStorage.getItem("nf_token");
      const r = await fetch(`${API}/reports/export/${fmt}`, { headers: { Authorization: `Bearer ${token}` } });
      if (!r.ok) throw new Error("Export failed");
      const blob = await r.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = `nakitflow-rapor.${fmt === "excel" ? "xlsx" : "pdf"}`;
      a.click(); URL.revokeObjectURL(url);
      toast.success(`${fmt.toUpperCase()} indirildi`);
    } catch (e) { toast.error("Dışa aktarma başarısız"); }
  };

  if (!data) return <div className="text-slate-500">Yükleniyor...</div>;

  return (
    <div className="space-y-5 nf-fade-up">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div>
          <div className="text-xs uppercase tracking-widest font-mono-num text-slate-500">RAPORLAR</div>
          <h1 className="font-head text-3xl font-extrabold tracking-tight">Kar / Zarar</h1>
        </div>
        <div className="flex gap-2">
          <Button data-testid="export-pdf-btn" onClick={() => download("pdf")} className="bg-rose-500/15 hover:bg-rose-500/25 text-rose-300 border border-rose-500/30"><FileDown className="w-4 h-4 mr-1.5" /> PDF İndir</Button>
          <Button data-testid="export-excel-btn" onClick={() => download("excel")} className="bg-emerald-500/15 hover:bg-emerald-500/25 text-emerald-300 border border-emerald-500/30"><FileSpreadsheet className="w-4 h-4 mr-1.5" /> Excel İndir</Button>
        </div>
      </div>

      <div className="grid lg:grid-cols-3 gap-4">
        {[
          { label: "Toplam Gelir", v: data.total_income, c: "emerald" },
          { label: "Toplam Gider", v: data.total_expense, c: "coral" },
          { label: "Net Kar/Zarar", v: data.net_profit, c: data.net_profit >= 0 ? "cyan" : "coral" },
        ].map((k) => (
          <div key={k.label} className="nf-card p-6">
            <div className="text-xs uppercase tracking-widest font-mono-num text-slate-500">{k.label}</div>
            <div className="font-head font-extrabold text-3xl font-mono-num mt-2" style={{
              color: k.c === "emerald" ? "#10B981" : k.c === "coral" ? "#F43F5E" : "#06B6D4"
            }}>{fmtTRY(k.v)}</div>
          </div>
        ))}
      </div>

      <div className="grid lg:grid-cols-2 gap-5">
        {[
          ["Gelir Dağılımı", data.income_by_category, "#10B981"],
          ["Gider Dağılımı", data.expense_by_category, "#F43F5E"],
        ].map(([title, rows, color]) => (
          <div key={title} className="nf-card p-6">
            <h2 className="font-head text-lg font-bold mb-4">{title}</h2>
            <div className="space-y-2">
              {rows.length === 0 && <div className="text-slate-500 text-sm">Veri yok</div>}
              {rows.map((r) => {
                const max = rows[0].amount;
                const w = max > 0 ? (r.amount / max) * 100 : 0;
                return (
                  <div key={r.category}>
                    <div className="flex items-center justify-between text-sm mb-1">
                      <span className="text-slate-300">{r.category}</span>
                      <span className="font-mono-num font-semibold" style={{ color }}>{fmtTRY(r.amount)}</span>
                    </div>
                    <div className="h-1.5 rounded-full bg-slate-800 overflow-hidden"><div className="h-full rounded-full" style={{ width: `${w}%`, background: color }} /></div>
                  </div>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
